import { AkaVeranstaltungId } from '../dtos.ts';

export function isAkaVeranstaltungId(akaVeranstaltungId: unknown): akaVeranstaltungId is AkaVeranstaltungId {
  return (
    typeof akaVeranstaltungId === 'string' && (akaVeranstaltungId.startsWith('V') || akaVeranstaltungId.startsWith('E'))
  );
}
